export const getHome = async (locale) => {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/home`, {
    headers: {
      "Accept-Language": locale,
    },
  });
  return res.json();
};
